import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web--source/slate/spacing";
import styled from "styled-components";
export var ProductError = styled.div.withConfig({
    componentId: "sc-7e1e3980-0"
})([
    "background-color:red;text-align:center;color:",
    ";"
], Core.text.default);
export var ImageContainer = styled.div.withConfig({
    componentId: "sc-7e1e3980-1"
})([
    "position:relative;"
]);
export var RetailInfoContainer = styled.div.withConfig({
    componentId: "sc-7e1e3980-2"
})([
    "flex:1;padding:",
    ";"
], getSpacing(12, 0, "1x", 0));
export var NotifyMeWrapper = styled.div.withConfig({
    componentId: "sc-7e1e3980-3"
})([
    "position:absolute;bottom:8px;right:8px;z-index:5;"
]);
